<div class="d-flex flex-wrap flex-stack mb-6">
  <h3 class="fw-bold my-2">My Horses</h3>
  <div class="d-flex flex-wrap my-2">
    <app-button
      [variant]="'primary'"
      [label]="'Add Horse'"
      [iconClass]="'fa fa-plus'"
      (clicked)="openModal()"
    />
  </div>
</div>
<div class="row g-6 mb-6 g-xl-9 mb-xl-9" [class.opacity-50]="loading" [class.pointer-events-none]="loading">
  @for (horse of horses; track horse.horse_id) {
    <div class="col-md-4">
      <app-horse-card
        [horse]="horse"
        (editHorseClick)="openEditModal($event)"
        (deleteHorseClick)="deleteHorse($event)"
      />
    </div>
  }
  @if (!loading && (!horses || horses.length === 0)) {
    <div class="col-12 text-center text-muted py-10">No horses found.</div>
  }
</div>


